'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setInboxFromElementCreate = exports.setInboxFromMultiElementMove = exports.closeInbox = exports.openInbox = undefined;

var _lodash = require('lodash');

var _elementHelper = require('../../common/elements/elementHelper');

var _undoRedoTransactionManager = require('../utils/undoRedo/undoRedoTransactionManager');

var _elementActions = require('../element/elementActions');

var _inboxConstants = require('./inboxConstants');

var _boardConstants = require('../../common/boards/boardConstants');

// Constants
// Lib
var openInbox = exports.openInbox = function openInbox(_ref) {
    var id = _ref.id,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync,
        _ref$transactionId = _ref.transactionId,
        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
    return (0, _elementActions.updateElement)({
        id: id,
        changes: {
            inbox: _inboxConstants.INBOX_STATE.OPEN
        },
        sync: sync,
        transactionId: transactionId
    });
};

// Util
var closeInbox = exports.closeInbox = function closeInbox(_ref2) {
    var id = _ref2.id,
        _ref2$sync = _ref2.sync,
        sync = _ref2$sync === undefined ? true : _ref2$sync,
        _ref2$transactionId = _ref2.transactionId,
        transactionId = _ref2$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref2$transactionId;
    return (0, _elementActions.updateElement)({
        id: id,
        changes: {
            inbox: _inboxConstants.INBOX_STATE.CLOSED
        },
        sync: sync,
        transactionId: transactionId
    });
};

// --------------------------------------------------
// logic for if we shoud open inbox on element move
// --------------------------------------------------

var shouldCloseCurrentBoardInbox = function shouldCloseCurrentBoardInbox(toLocation, fromLocation, state) {
    if (fromLocation.section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;

    // never close the inbox if you're dragging to the inbox
    if (fromLocation.parentId === toLocation.parentId && toLocation.section === _boardConstants.BOARD_SECTIONS.INBOX) return false;

    // in inbox is already closed, don't close it again
    var currentParentEl = state.get('elements').get(fromLocation.parentId);
    if (currentParentEl && currentParentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.CLOSED) return false;

    var currentInboxChildren = (0, _elementHelper.getChildrenInSection)((0, _elementHelper.getChildren)(state.get('elements'), fromLocation.parentId), _boardConstants.BOARD_SECTIONS.INBOX);

    // if there's still chidren in the current inbox, don't do anything
    if (currentInboxChildren.size > 0) return false;

    return true;
};

var shouldOpenTargetInbox = function shouldOpenTargetInbox(tolocation, fromLocation, state) {
    // never open up inbox if you're moving to canvas
    if (tolocation.section === _boardConstants.BOARD_SECTIONS.CANVAS) return false;

    // never open up the inbox automatically if you're on the same parent
    if (fromLocation.parentId === tolocation.parentId) return false;

    // trash doesn't have an inbox!
    if (tolocation.parentId.indexOf('trash') !== -1) return false;

    var parentEl = state.get('elements').get(tolocation.parentId);

    // if inbox is already open, don't open it again
    if (parentEl && parentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.OPEN) return false;

    return true;
};

/**
 * Performs a multi-update which includes any of the inbox state changes that should occur as a result of the moves.
 */
var setInboxFromMultiElementMove = exports.setInboxFromMultiElementMove = function setInboxFromMultiElementMove(_ref3) {
    var moves = _ref3.moves,
        _ref3$transactionId = _ref3.transactionId,
        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId;
    return function (dispatch, getState) {
        var state = getState();

        // Determine the inbox state changes that need to be made as a result of the moves
        var inboxStateMap = moves.reduce(function (inboxMap, move) {
            var fromLocation = move.from;
            var toLocation = move.location;

            if (shouldCloseCurrentBoardInbox(toLocation, fromLocation, state)) {
                inboxMap[fromLocation.parentId] = _inboxConstants.INBOX_STATE.CLOSED;
            }
            if (shouldOpenTargetInbox(toLocation, fromLocation, state)) {
                inboxMap[toLocation.parentId] = _inboxConstants.INBOX_STATE.OPEN;
            }
            return inboxMap;
        }, {});

        // Build an array of updates given the inbox state changes that need to be made
        var inboxUpdates = (0, _lodash.map)(inboxStateMap, function (inboxState, id) {
            return {
                id: id,
                changes: {
                    inbox: inboxState
                }
            };
        });

        // If there's no updates, then don't dispatch the action.
        if (inboxUpdates.length === 0) return;

        dispatch((0, _elementActions.updateMultipleElements)({ updates: inboxUpdates, transactionId: transactionId }));
    };
};

// --------------------------------------------------
// logic for if we should open inbox on element create
// --------------------------------------------------

var shouldOpenInboxFromElementCreate = function shouldOpenInboxFromElementCreate(toLocation, state) {
    var parentId = toLocation.parentId,
        section = toLocation.section;

    // don't open the inbox if we aren't creating something in the inbox

    if (section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;

    var parentEl = state.get('elements').get(parentId);

    // if inbox is already open, don't open it again
    if (parentEl && parentEl.get('content').get('inbox') === _inboxConstants.INBOX_STATE.OPEN) return false;

    return true;
};

var setInboxFromElementCreate = exports.setInboxFromElementCreate = function setInboxFromElementCreate(_ref4) {
    var location = _ref4.location,
        _ref4$transactionId = _ref4.transactionId,
        transactionId = _ref4$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref4$transactionId;
    return function (dispatch, getState) {
        var shouldOpenInbox = shouldOpenInboxFromElementCreate(location, getState());
        if (shouldOpenInbox) dispatch(openInbox({ id: location.parentId, transactionId: transactionId }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/inboxActions.js
// module id = 305
// module chunks = 0